// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-wrap {\n  padding: 5px;\n}\n.rank-table {\n  width: 100%;\n  border-collapse: collapse;\n  color: #000000;\n  font-size: 14px;\n}\n/* 表頭 */\n.rank-table thead th {\n  font-weight: bold;\n  text-align: left;\n  padding: 10px 10px;\n  border: 1px solid #444;\n}\n\n/* 表身 */\n.rank-table tbody td {\n  padding: 10px 10px;\n  border: 1px solid #444;\n}\n", ""]);
// Exports
module.exports = exports;
